// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__22ivd","label":"LabeledBox_label__4dA1B"};